<template>
  <div v-loading="isBusy">
    <el-tabs value="common">
      <el-tab-pane label="Common" name="common">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          element-loading-spinner="el-icon-loading"
          label-width="170px"
        >
          <el-form-item label="Brand" prop="brand_id">
            <el-select v-model="form.brand_id">
              <el-option
                v-for="{value, label} in brandOptions"
                :key="value"
                :value="value"
                :label="label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Name" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="Signature" prop="signature">
            <tinymce-editor v-model="form.signature" id="signature" ref="signature"></tinymce-editor>
            <placeholders @select="addPlaceholder" :items="placeholders">
              <el-tooltip content="Placeholders" placement="top">
                <span class="color--prpl cursor-pointer"><i class="fas fa-code"></i></span>
              </el-tooltip>
            </placeholders>
          </el-form-item>
        </el-form>
        <button class="btn btn-purple px-4" @click="store">Store</button>
      </el-tab-pane>
      <el-tab-pane label="User Bindings" name="binding" v-if="isEditMode">
        <users-table v-bind="usersTableAttrs"></users-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BaseForm from '../form';
import UsersTable from './users/table';
import TinymceEditor from '../tinymce-editor';
import Placeholders from '../shared/placeholder/list';

const placeholders = [
  {key: 1, value: '[[representative_name]]'},
  {key: 2, value: '[[representative_email]]'},
  {key: 3, value: '[[brand_title]]'},
];

export default {
  extends: BaseForm,

  components: {
    UsersTable,
    TinymceEditor,
    Placeholders,
  },

  props: {
    usersTableAttrs: Object,
    brandOptions: Array,
  },

  data() {
    const form = {
      brand_id: null,
      name: null,
      signature: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      placeholders: placeholders,
    }
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },

    /**
     * @param {string} value
     */
    addPlaceholder(value) {
      this.$refs.signature.editor.execCommand('mceInsertContent', false, value);
    },
  },
}
</script>
